/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from 'react';

import mapModifiers from 'utils/functions';

interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  name: string;
  value: string;
  checkedValue: string;
  type?: 'circle' | 'check' | 'checkBlack';
  theme?: 'light' | 'dark';
  paddingRightLabel?: 'md';
  color?: ColorStyle;
  disabled?: boolean;
}

const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({
    id,
    name,
    children,
    value,
    checkedValue,
    type,
    theme,
    paddingRightLabel,
    color,
    onChange,
    disabled = false,
    ...props
  }, ref) => (
    <div className={mapModifiers('a-radio', type, theme, color)}>
      <div className="a-radio_main">
        <input
          className="a-radio_main_input"
          type="radio"
          id={id}
          ref={ref}
          name={name}
          value={value}
          checked={value === checkedValue}
          onChange={onChange}
          disabled={disabled}
          {...props}
        />
        <span className="a-radio_checkmark" />
        <label className={mapModifiers('a-radio_main_label', paddingRightLabel, disabled && 'disabled')} htmlFor={id}>{children || ''}</label>
      </div>
    </div>
  ),
);

Radio.defaultProps = {
  theme: 'light',
  type: 'circle',
  paddingRightLabel: undefined,
  color: 'raisinBlack',
  disabled: undefined,
};

export default Radio;
